import SaAlgorithm = ToroEnums.SaAlgorithm;
import SaMinThreshOption = ToroSaEnums.SaMinThresholdOption;

import { ToroEnums } from '../../../common/enumerations/toro.enums';
import { ToroSaEnums } from '../../../spatial-adjust/enums/spatial-adjust.enums';

export class SpatialAdjustSettings {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    siteId: number;
    saAlgorithm: SaAlgorithm = SaAlgorithm.DeltaPlusTodayEt;
    saMaxAmountMm: number;
    saReferenceAmountMm: number;
    saCropCoefficientPercent: number;
    saMinThresholdPercent: number;
    saMinThresholdOption: SaMinThreshOption
}
